export const CLEAR_MARKERS = 'CLEAR_MARKERS'
export const SET_MARKERS = 'SET_MARKERS'
export const SET_CAN_CREATE_MARKER = 'SET_CAN_CREATE_MARKER'
